import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './CustomOrderPage.css';

function DeliveryPlaceAutocomplete({ value, onChange }) {
  // Reuse from CustomOrderPage
  const [inputValue, setInputValue] = useState(value || '');
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const debounceRef = React.useRef(null);

  useEffect(() => { setInputValue(value || ''); }, [value]);

  const handleChange = (e) => {
    const val = e.target.value;
    setInputValue(val);
    onChange(val);
    setShowDropdown(true);
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      if (!val) { setSuggestions([]); setLoading(false); return; }
      if (window.google && window.google.maps && window.google.maps.places && window.google.maps.places.fetchSuggestion) {
        setLoading(true);
        window.google.maps.places.fetchSuggestion({ input: val })
          .then((response) => {
            setLoading(false);
            if (response && Array.isArray(response.suggestions)) {
              setSuggestions(response.suggestions);
            } else {
              setSuggestions([]);
            }
          })
          .catch(() => { setLoading(false); setSuggestions([]); });
      }
    }, 300);
  };
  const handleSelect = (desc) => { setInputValue(desc); onChange(desc); setSuggestions([]); setShowDropdown(false); };
  return (
    <div className="autocomplete-root" style={{ position: 'relative' }}>
      <input
        value={inputValue}
        onChange={handleChange}
        placeholder="Start typing address..."
        className="autocomplete-input"
        autoComplete="off"
        onFocus={() => setShowDropdown(true)}
        onBlur={() => setTimeout(() => setShowDropdown(false), 150)}
      />
      {showDropdown && suggestions.length > 0 && (
        <div className="autocomplete-dropdown">
          {suggestions.map((suggestion) => (
            <div
              key={suggestion.placeId || suggestion.place_id || suggestion.description}
              className="autocomplete-item"
              onMouseDown={() => handleSelect(suggestion.description)}
            >
              {suggestion.description}
            </div>
          ))}
        </div>
      )}
      {loading && <div className="autocomplete-dropdown">Loading...</div>}
    </div>
  );
}

export default function CakeOrderPage({ cake: cakeProp, currentUser, onOrderCreated }) {
  const location = useLocation();
  const navigate = useNavigate();
  const cake = cakeProp || (location.state && location.state.cake) || {};
  const [customer, setCustomer] = useState('');
  const [customerNumber, setCustomerNumber] = useState('');
  const [deliveryPlace, setDeliveryPlace] = useState('');
  const [cakeWritings, setCakeWritings] = useState('');
  const [description, setDescription] = useState('');
  const [pickDate, setPickDate] = useState('');
  const [pickTime, setPickTime] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [localUser, setLocalUser] = useState(currentUser || null);

  useEffect(() => {
    if (!currentUser) {
      const savedUser = localStorage.getItem('user');
      if (savedUser) setLocalUser(JSON.parse(savedUser));
    }
  }, [currentUser]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    if (!customer || !customerNumber || !deliveryPlace || !cakeWritings || !pickDate || !pickTime) {
      setError('Please complete all required fields.');
      return;
    }
    setSubmitting(true);
    try {
      const orderData = {
        customer,
        customerNumber,
        deliveryPlace,
        cakeWritings,
        description,
        pickDate,
        pickTime,
        createdBy: localUser?.uid,
        createdByName: localUser?.displayName || localUser?.name || localUser?.email || '',
        createdByPhoto: localUser?.photoURL || localUser?.photoUrl || '',
        images: cake?.imageUrls || [],
        cakePrice: cake?.price || '',
        cakeId: cake?.id || '',
        cakeName: cake?.name || '',
        customerorder: false,
        verified: false,
        company: 'cakedoctor'
      };
      const res = await fetch('https://devbite.vercel.app/api/cake_order', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(orderData),
      });
      if (!res.ok) throw new Error('Failed to save order');
      if (onOrderCreated) onOrderCreated();
      setSubmitting(false);
      window.location.href = '/myorders';
    } catch (err) {
      setError(err.message || 'Failed to create order');
      setSubmitting(false);
    }
  };

  return (
    <div className="custom-order-bg">
      <header className="custom-order-appbar">
        <button className="custom-order-back" onClick={() => navigate(-1)}>&larr;</button>
        <span className="custom-order-appbar-title">Cake Order</span>
      </header>
      <div className="custom-order-root">
        <h2>Order Cake: {cake?.name}</h2>
        <form className="custom-order-form" onSubmit={handleSubmit}>
          <label>Customer Name*</label>
          <input value={customer} onChange={e => setCustomer(e.target.value)} required />
          <label>Customer Number*</label>
          <input value={customerNumber} onChange={e => setCustomerNumber(e.target.value)} required />
          <label>Delivery Place*</label>
          <DeliveryPlaceAutocomplete value={deliveryPlace} onChange={setDeliveryPlace} />
          <label>Cake Writings*</label>
          <input value={cakeWritings} onChange={e => setCakeWritings(e.target.value)} required />
          <label>Description</label>
          <textarea value={description} onChange={e => setDescription(e.target.value)} />
          <label>Pick Date*</label>
          <input type="date" value={pickDate} onChange={e => setPickDate(e.target.value)} required />
          <label>Pick Time*</label>
          <input type="time" value={pickTime} onChange={e => setPickTime(e.target.value)} required />
          {error && <div className="form-error">{error}</div>}
          <button type="submit" disabled={submitting}>{submitting ? 'Submitting...' : 'Submit Order'}</button>
        </form>
      </div>
    </div>
  );
}
